import { render, staticRenderFns } from "./lead-link-modal.vue?vue&type=template&id=4d6175e8&scoped=true"
import script from "./lead-link-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./lead-link-modal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6175e8",
  null
  
)

export default component.exports